/**
 * Enum SafeType
 * @author Mario S. Alves
 */
export enum SafeType {
    HTML = 'HTML',
    STYLE = 'STYLE',
    SCRIPT = 'SCRIPT',
    URL = 'URL',
    RESOURCEURL = 'RESOURCEURL',
    NOTHING = 'NOTHING',
}
